<div class="error-container">
    <h1>¡Error 404!</h1>
    <p>La página que estás buscando no existe.</p>
    <a routerLink="/home">Volver a la página de inicio</a>
  </div>
  
